import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserProDataSet } from 'src/app/shared/models/user-pro-data-set';
import { UserProDataSetProperty } from 'src/app/shared/models/user-pro-data-set-property';
import { ImportService } from 'src/app/shared/services/import.service';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';

@Component({
  selector: 'app-edit-data-set-modal',
  templateUrl: './edit-data-set-modal.component.html',
  styleUrls: ['./edit-data-set-modal.component.scss']
})
export class EditDataSetModalComponent implements OnInit {

  //all non super admin users - DATA SET CANNOT BE CREATED FOR SUPER ADMIN
  //nonSuperAdminUsers: any[] = [];

  //list of property names
  partnerProProperties: string[];

  //list of all available properties - will include prop name and isSelected values
  selectableProperties: any[] = [];

  //the user we are creating the new data set for
  selectedUser: any;

  selectedProType: string;

  //represents the pro type we're selecting for
  // selectedProType: string;

  //list of pro type options
  proTypes: string[] = [];

  userDataSets: UserProDataSet[] = [];

  selectedDataSet: UserProDataSet;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<EditDataSetModalComponent>, private importService: ImportService, private partnerService: PartnerService, private snackbarService: SnackBarService) {
    this.selectedUser = data.selectedUser;
    this.selectedProType = data.proType;
  }

  ngOnInit() {
    //get data set for selectedUser
    this.partnerService.getUserDataSets(this.selectedUser.id).subscribe(resDataSets => {
      this.userDataSets = resDataSets;

      this.selectedDataSet = this.userDataSets.find(set => set.proType == this.selectedProType);

      //clear values for resetting
      this.selectableProperties = [];

      if (this.selectedDataSet) {
        //if the dataset exist - use settings
        this.selectedDataSet.properties.forEach(prop => {

          if (this.includeProperty(prop.propertyName)) {

            let selectableProp = {
              isRestricted: prop.isRestricted,
              name: prop.propertyName
            };

            this.selectableProperties.push(selectableProp);
          }
        })

      }
      else {
        //we haven't created this dataset yet
        //use default where no properties are selected

        this.importService.approvedCatLabels$.subscribe((x) => {
          this.partnerProProperties = x;

          this.partnerProProperties.forEach(prop => {

            if (this.includeProperty(prop)) {
              let selectableProp = {
                isSelected: true,
                isRestricted: true,
                name: prop
              };

              this.selectableProperties.push(selectableProp);
            }
          })
        })

      }


      //track approved cat labels & add to list if missing
      this.importService.approvedCatLabels$.subscribe((x) => {
        this.partnerProProperties = x;

        this.partnerProProperties.forEach(prop => {

          if (!this.selectableProperties.some(item => item.name == prop)) {

            if (this.includeProperty(prop)) {
              //for some reason, this property wasn't included with the original list, add it here
              let selectableProp = {
                isRestricted: true, //default to not selected
                name: prop
              };

              this.selectableProperties.push(selectableProp);
            }
          }
        })

      })

    })


  }

  onClose(): void {
    this.dialogRef.close();
  }

  //selects all properties for viewing
  selectAllProperties() {
    this.selectableProperties.forEach(item => {
      item.isRestricted = false;
    })
  }

  setPropertyRestriction(property: UserProDataSetProperty) {
    property.isRestricted = !property.isRestricted;
  }

  //returns false if the property isn't a column
  includeProperty(prop: string): boolean {
    return this.partnerService.masterColumns.some(col => col.name.toLowerCase() === prop.toLowerCase());
  }

  /**
   * Updates the dataset or creates new if needed
   */
  updateDataSet() {

    //will set to true if we determine we need to create a new dataset
    var createNew = false;

    if (this.selectedDataSet == undefined) {

      //we're creating a new dataset. Set up the base properties

      createNew = true;

      this.selectedDataSet = new UserProDataSet();
      this.selectedDataSet.userId = this.selectedUser.id;
      this.selectedDataSet.proType = this.selectedProType;
      this.selectedDataSet.properties = [];

      //next, add all of the chosen properties (restrictions considered) 
      //default isSelected = true
      this.selectableProperties.forEach(prop => {

        var property = new UserProDataSetProperty();
        property.propertyName = prop;
        property.isSelected = true;
        property.isRestricted = prop.isRestricted;

        this.selectedDataSet.properties.push(property);
      })
    }
    else {

      //we're updating an existing dataset. Update the isResticted value for each property

      this.selectableProperties.forEach(prop => {
        var property = this.selectedDataSet.properties.find(p => p.propertyName == prop.name);

        if (property) {
          //changing this to control restricted properties vs selected
          //I assume we'll let the user select their own properties to view
          property.isRestricted = prop.isRestricted;
        }
      })
    }

    if (!createNew) {
      //update existing dataset
      this.partnerService.updateUserProDataSet(this.selectedDataSet).subscribe(
        (resDataSet) => {
          this.snackbarService.showSnackBarMessage("Data set successfully updated", "Close");

          this.onClose();
        },
        (error) => {
          //handle error
          this.snackbarService.showSnackBarMessage("An error occurred updating the data set.", "Close", undefined, true);
        }
      )
    }
    else {
      //create new dataset
      const formattedProperties = this.selectedDataSet.properties.map(prop => ({
        isSelected: prop.isSelected,
        name: prop.propertyName,
        isRestricted: prop.isRestricted
      }));

      this.partnerService.postDataSet(this.selectedDataSet.userId, this.selectedDataSet.proType, formattedProperties).subscribe(
        (resDataSet) => {
          this.selectedDataSet = resDataSet;

          //save to global selectedDataSet
          this.partnerService.setCurrentUserSelectedDataSet(this.selectedDataSet);
        },
        (error) => {
          //handle error
          this.snackbarService.showSnackBarMessage("An error occurred updating the data set.", "Close", undefined, true);
        })
    }
  }

}